import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Cards from "./components/Cards";
import Intro from "./components/Intro";
import Contact from "./components/Contact";

function App()
{
  return(
    <Intro>
      <Navbar/>
      <Hero/>
      <Cards/>
      <Contact/>
    </Intro>
  );
}

export default App;